import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka anteckningar måste jag föra i verksamheten?";
const SHORT_ANSWER = "Kassaregisterunderlag, inköpsverifikationer för alkohol, anteckningar om incidenter (avvisade gäster, avbruten servering) samt personalens arbetstider.";

export const Route = createFileRoute("/fraga/vilka-anteckningar-maste-jag-fora")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka anteckningar måste jag föra i verksamheten" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Skatteverket och kommunen kan begära in dessa vid tillsyn. Bristande underlag, t.ex. kontantförsäljning som inte registreras, är ett vanligt skäl till varning eller återkallat tillstånd."}
      source={{ label: "Skatteverket – Personlig och ekonomisk lämplighet", href: "https://www.skatteverket.se/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Bokföring och anteckningskrav" }}
      related={[{"to": "/fraga/vad-galler-vid-personalfest", "label": "Får jag servera alkohol på personalfest utan extra tillstånd?"}, {"to": "/fraga/far-personalen-dricka-pa-jobbet", "label": "Får personalen dricka alkohol under arbetspasset?"}, {"to": "/fraga/vad-ar-egenkontrollprogram", "label": "Vad är ett egenkontrollprogram?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka anteckningar måste jag föra i verksamheten?" },
      { name: "description", content: "Kassaregisterunderlag, inköpsverifikationer för alkohol, anteckningar om incidenter (avvisade gäster, avbruten servering) samt personalens arbetstider." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-anteckningar-maste-jag-fora" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-anteckningar-maste-jag-fora" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-anteckningar-maste-jag-fora",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka anteckningar måste jag föra i verksamheten", url: "https://alkoholprovet.se/fraga/vilka-anteckningar-maste-jag-fora" },
      ]),
    ],
  }),
});
